<template>
  <div class="container-fluid">
    <div class="btn-toolbar" role="toolbar">
      <button @click="save" id="comsave" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button><br/><br/>
    </div>
    <div class="row">
      <div class="col">
        <h4>Produktempfehlungsparameter:</h4>
        <div class="form-group">
          <label>Min. Support</label>
          <b-form-input v-model="config['statistic.cart.prediction.minsupport']" type="range" min="0" max="1" step="0.01"></b-form-input>
          <p class="text-muted small">
            Bestimmt an wievielen Transaktionen (Prozentual) ein Produkt teilgenommen haben muss um in die Berechnung mit übernommen zu werden.
          </p>
        </div>
        <div class="form-group">
          <label>Min. Gruppierung</label>
          <b-form-input v-model="config['statistic.cart.prediction.mingroup']" type="range" min="0" max="1" step="0.01"></b-form-input>
          <p class="text-muted small">
            Bestimmt die benötigte Stärke einer Verbindung aus den Warenkörben zur Übernahme als Feste Empfehlung.
          </p>
        </div>
      </div>
      <div class="col">
        <h4>Neuberechnung Produktempfehlungen</h4>
        <CronExprBuilder ref="scheduler"/>
      </div>
    </div>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import CronExprBuilder from '@/components/CronExprBuilder.vue'

export default {
  name: 'StatisticAIConfig',
  components: {
    CronExprBuilder
  },
  data() {
    return {
      needs: ["statistic.cart.prediction.mingroup","statistic.cart.prediction.minsupport","statistic.cart.predictions.cron"],
      config: {}
    }
  },
  created: function() {
    console.log('Statistik AI Init');
    var self = this;
    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
      self.$refs.scheduler.cron = data["statistic.cart.predictions.cron"];
    })
  },
  methods: {
    save: function() {
      console.log('save',this.config,this.$refs.scheduler.cron);
      this.config["statistic.cart.predictions.cron"] = this.$refs.scheduler.cron;
      var self = this;
      config.savecfg(this.config,this,function() {
        self.$bvToast.toast('Konfiguration gespeichert',{title:'Allgemein',variant: 'success'});
      })
    }
  }
}

</script>
